import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import {
  getDatasetCommands,
  getIsCommandsCreated,
} from '../../../store/selectors/commands';
import {
  getDatasetConditionsCount,
  getDatasetConfigCurrentPreset,
} from '../../../store/selectors/dataset';
import commands from '../../../store/slices/commands';

import CommandsToolbar from './CommandsToolbar';

interface Props {
  datasetId: UniqueId;
  className?: string;
}

const mapStateToProps = (state: AppState, { datasetId }: Props) => ({
  conditionsCount: getDatasetConditionsCount(state, datasetId),
  commands: getDatasetCommands(state, datasetId),
  isCommandsCreated: getIsCommandsCreated(state, datasetId),
  toolbarCommandsConfig: getDatasetConfigCurrentPreset(state, datasetId)
    .toolbarCommands,
});

const mapDispatchToProps = {
  onInitiate: commands.initiate,
};

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { onInitiate }: typeof mapDispatchToProps,
  { datasetId, className }: Props
) => ({
  ...stateProps,
  className,
  onInitiateCommand: (command: string) => onInitiate({ datasetId, command }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type CommandsToolbarContainerProps = ConnectedProps<typeof connector>;

export default connector(CommandsToolbar);
